import React from "react";
import ReactDOM from "react-dom/client";
// Polices auto-hébergées (ex-Google Fonts) : mêmes familles/graisses, servies en
// same-origin → préchargeables dans les snapshots prerendus (LCP texte stable).
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/plus-jakarta-sans/400.css";
import "@fontsource/plus-jakarta-sans/500.css";
import "@fontsource/plus-jakarta-sans/600.css";
import "@fontsource/plus-jakarta-sans/700.css";
import "@fontsource/plus-jakarta-sans/800.css";
import "@/index.css";
import App from "@/App";

// Neutralise le bruit "ResizeObserver loop" (Radix UI) qui déclenche l'overlay
// d'erreur du mode dev — sans effet en production, aucun impact fonctionnel.
window.addEventListener("error", (e) => {
  if (e.message && e.message.includes("ResizeObserver loop")) e.stopImmediatePropagation();
});

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);
const mount = () =>
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

// Page prerendue (#root déjà rempli par le snapshot statique) : on laisse le
// premier écran statique émettre son paint LCP (image hero décodée + polices
// chargées + un frame rendu) AVANT le montage React — sinon le re-rendu React
// détruit/recrée le DOM et le LCP mesuré devient dépendant de tout le bundle JS.
// Plafonné à 400 ms : l'interactivité n'est jamais retardée perceptiblement.
if (container.firstElementChild) {
  const lcpImg = container.querySelector('img[fetchpriority="high"]');
  const ready = Promise.all([
    lcpImg && lcpImg.decode ? lcpImg.decode().catch(() => {}) : Promise.resolve(),
    document.fonts ? document.fonts.ready : Promise.resolve(),
  ]).then(() => new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r))));
  Promise.race([ready, new Promise((r) => setTimeout(r, 400))]).then(mount);
} else {
  mount();
}
